/* California High cart page: mobile sticky checkout bar + subtotal sync.
   Perf (Sept 2026): IntersectionObserver on the real Check out button replaces scroll/resize/click
   listeners and per-scroll getBoundingClientRect reads (no layout work while scrolling).
   Depends on pubsub.js (subscribe / PUB_SUB_EVENTS.cartUpdate), loaded by layout/theme.liquid. */
(function () {
  function init() {
    var footer = document.getElementById('main-cart-footer');
    var sticky = document.getElementById('ChCartSticky');
    var checkout = document.getElementById('checkout');
    if (!footer || !sticky || !checkout || !('IntersectionObserver' in window)) return;

    var mq = window.matchMedia('(max-width: 749px)');
    var stickyValue = sticky.querySelector('[data-ch-sticky-subtotal]');
    var below = false; // real button is below the viewport

    function bannerOpen() {
      // Shopify's cookie banner owns the bottom edge while it is open.
      var b = document.getElementById('shopify-pc__banner');
      return !!(b && b.offsetHeight > 0);
    }

    function render() {
      var on = below && mq.matches && !footer.classList.contains('is-empty') && !bannerOpen();
      if (sticky.classList.contains('is-visible') === on) return;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('ch-cart-sticky-active', on);
    }

    // Root extended far upward: "intersecting" means the button's top edge is above the viewport's
    // bottom (on screen or scrolled past). Fires once per crossing, including instant jumps.
    new IntersectionObserver(function (entries) {
      below = !entries[entries.length - 1].isIntersecting;
      render();
    }, { rootMargin: '100000px 0px 0px 0px' }).observe(checkout);

    if (mq.addEventListener) mq.addEventListener('change', render);
    // Re-check when the visitor answers the cookie banner.
    document.addEventListener('visitorConsentCollected', function () { setTimeout(render, 50); });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        var live = footer.querySelector('[data-ch-subtotal]');
        if (live && stickyValue) stickyValue.textContent = live.textContent.trim();
        render();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
